import {
  StandardizedOnboardingData,
  validateOnboardingData,
} from "./onboardingDataTransformer";

export interface ValidationErrors {
  isValid: boolean;
  errors: string[];
  warnings: string[];
}

export const formatTime = (time: string): string => {
  if (!time || time.length !== 4) return time;
  const hours = parseInt(time.substring(0, 2));
  const minutes = time.substring(2, 4);
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${minutes} ${ampm}`;
};

export const validateCompleteData = (
  data: StandardizedOnboardingData | null
): ValidationErrors => {
  if (!data) {
    return {
      isValid: false,
      errors: ["No onboarding data available"],
      warnings: [],
    };
  }

  const { isValid, errors } = validateOnboardingData(data);
  const warnings: string[] = [];

  if (!data.store.phone) {
    warnings.push("Phone number is not provided");
  }
  if (!data.store.openingHours || data.store.openingHours.length === 0) {
    warnings.push("Operating hours are not specified");
  }
  if (!data.store.storeTag || data.store.storeTag.length === 0) {
    warnings.push("No store tags assigned");
  }
  if (!data.merchant.domain) {
    warnings.push("Website URL is not provided");
  }
  if (!data.store.signature) {
    warnings.push("Store signature is not specified");
  }

  return {
    isValid,
    errors,
    warnings,
  };
};

export const getDayName = (dayIndex: number): string => {
  const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return dayNames[dayIndex] || "";
};
